module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [_vm.e.theme, {
      compactly: _vm.compactly
    }]
  }, [_c('header', [_c('e-title', {
    attrs: {
      "e": _vm.e,
      "extended": false,
      "no-time": _vm.noTime
    }
  })], 1), _vm._v(" "), (_vm.hasContent) ? _c('e-content', {
    attrs: {
      "text": _vm.e.annotation
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2144fe2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/index.vue
// module id = 156
// module chunks = 1